import React, { useState } from 'react'
import SliderEmpresas from './SliderEmpresas';
import ContactoAnuncia from './ContactoAnuncia';

const Anuncia = () => {
    const [selectedOption, setSelectedOption] = useState(null);

    const cambiarOpcion = () => {
        setSelectedOption('first');
    }
    const cambiarOpcion2 = () => {
        setSelectedOption('second');
    }
    const cambiarOpcion3 = () => {
        setSelectedOption('third');
    }
    const cambiarOpcion4 = () => {
        setSelectedOption('fourth');
    }
    const cambiarOpcion5 = () => {
        setSelectedOption('fifth');
    }
    return (
        <>
            <div className='ed-pagina'>
            <header className="ed-shell ed-pagina__cabecera">
                <p className="ed-kicker">Anuncia con nosotros</p>
                <h1 className="ed-pagina__titulo">Empresas que nos acompañan</h1>
                <p className="ed-pagina__entradilla">
                    Marcas que confían en Cámara AQP para llegar al empresariado de la región.
                </p>
            </header>
            <div className="ed-shell">
                <SliderEmpresas />
                </div>

                <div className='empresas_seccion'>
                    <nav className='empresas_navbar'>
                        <div className="container">
                            <ul className="options">
                                <li><button
                                    onClick={cambiarOpcion}
                                    className={selectedOption === 'first' ? 'selected' : ''}
                                >¿Qué ofrecemos?</button></li>
                                <li><button
                                    onClick={cambiarOpcion2}
                                    className={selectedOption === 'second' ? 'selected' : ''}
                                >¿Qué nos diferencia de otras revistas?</button></li>
                                <li><button
                                    onClick={cambiarOpcion3}
                                    className={selectedOption === 'third' ? 'selected' : ''}
                                >¿Por qué confiar en nosotros?</button></li>
                                <li><button
                                    onClick={cambiarOpcion4}
                                    className={selectedOption === 'fourth' ? 'selected' : ''}
                                >Precios</button></li>
                                <li><button
                                    onClick={cambiarOpcion5}
                                    className={selectedOption === 'fifth' ? 'selected' : ''}
                                >Contacto</button></li>
                            </ul>
                        </div>
                    </nav>
                </div>
                <div className="ed-laminas ed-shell">
                {selectedOption === 'first' && (
                    <img src="/ofrecemos.webp" className="img_empresas" alt="Flowbite Logo" loading="lazy" decoding="async" />
                )}
                {selectedOption === 'second' && (
                    <img src="/diferencia.webp" className="img_empresas" alt="Flowbite Logo" loading="lazy" decoding="async" />
                )}
                {selectedOption === 'third' && (
                    <img src="/confiar.webp" className="img_empresas" alt="Flowbite Logo" loading="lazy" decoding="async" />
                )}
                {selectedOption === 'fourth' && (
                    <>
                        <img src="/precios1.webp" className="img_empresas" alt="Flowbite Logo" loading="lazy" decoding="async" />
                        <img src="/precios2.webp" className="img_empresas" alt="Flowbite Logo" loading="lazy" decoding="async" />
                    </>
                )}
                {selectedOption === 'fifth' && <ContactoAnuncia />}
                </div>
            </div>
        </>
    )
}

export default Anuncia
